"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Render OrderDisplay
 *
 * @class OrderDisplay
 * @public
 *
 * @returns {React.ReactElement}
 */

class OrderDisplay extends _react.Component {
  render() {
    const {
      items,
      itemsTitle,
      subTotal,
      subTotalPrefix,
      taxesTotal,
      taxesTotalPrefix
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "order-font-base order-display"
    }, itemsTitle && /*#__PURE__*/_react.default.createElement("span", null, itemsTitle), items && items.length > 0 && /*#__PURE__*/_react.default.createElement("ul", null, items.map(item => item.name && /*#__PURE__*/_react.default.createElement("li", {
      key: item.name
    }, /*#__PURE__*/_react.default.createElement("strong", null, item.name, " ", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("small", null, item.term))))), /*#__PURE__*/_react.default.createElement("p", null, subTotalPrefix && subTotal && /*#__PURE__*/_react.default.createElement("small", null, subTotalPrefix, " ", /*#__PURE__*/_react.default.createElement("strong", null, subTotal)), taxesTotalPrefix && taxesTotal && /*#__PURE__*/_react.default.createElement("small", null, taxesTotalPrefix, " ", /*#__PURE__*/_react.default.createElement("strong", null, taxesTotal))));
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */

OrderDisplay.propTypes = {
  /** List of items in the order */
  items: _propTypes.default.array,
  /** Message seen before item breakdown  */
  itemsTitle: _propTypes.default.string,
  /** Total of order before taxes */
  subTotal: _propTypes.default.string,
  /** Message to describe subtotal */
  subTotalPrefix: _propTypes.default.string,
  /** Total of taxes */
  taxesTotal: _propTypes.default.string,
  /** Message to describe taxes */
  taxesTotalPrefix: _propTypes.default.string
};
var _default = OrderDisplay;
exports.default = _default;